'use client'

import React, { useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import Link from 'next/link';
import { useEinwilligung, ZUGESTIMMT } from '@/lib/einwilligung';

const HOEHE = 500;

/**
 * Google-Maps-Karte, die erst nach Einwilligung laedt.
 *
 * Vorher stand hier ein iframe, das bei jedem Aufruf der Kontaktseite eine
 * Verbindung zu Google herstellte und dabei die IP-Adresse der Besucherin
 * uebertrug - unabhaengig davon, was sie im Cookie-Hinweis gewaehlt hatte.
 *
 * Jetzt gilt: geladen wird nur bei Zustimmung, oder wenn die Karte hier
 * ausdruecklich angefordert wird. Die Anforderung ueber den Knopf gilt nur
 * fuer diesen Besuch und wird nicht gespeichert.
 */
export const Karte = ({ eingebettetUrl, kartenUrl }) => {
    const einwilligung = useEinwilligung();
    const [einmaligGeladen, setEinmaligGeladen] = useState(false);

    const anzeigen = einwilligung === ZUGESTIMMT || einmaligGeladen;

    return (
        <Paper elevation={3} sx={{ overflow: 'hidden' }}>
            {anzeigen ? (
                <iframe
                    title="Standort Marlene Gujan Architektur AG auf Google Maps"
                    src={eingebettetUrl}
                    width="100%"
                    height={HOEHE}
                    style={{ border: 0, display: 'block' }}
                    allowFullScreen=""
                    loading="lazy"
                    // no-referrer statt no-referrer-when-downgrade: letzteres
                    // schickt von https auf https die VOLLE Adresse der
                    // Kontaktseite an Google mit. Die Einbettung funktioniert
                    // ohne Referrer unveraendert. Siehe SICHERHEIT.md,
                    // Befund 6.
                    referrerPolicy="no-referrer"
                />
            ) : (
                <Box
                    sx={{
                        height: HOEHE,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        px: 3,
                        textAlign: 'center',
                        backgroundColor: '#f2f2f2',
                    }}
                >
                    <Typography variant="body2" sx={{ maxWidth: '32rem' }}>
                        Hier wird eine Karte von Google Maps angezeigt. Beim Laden wird eine
                        Verbindung zu Google hergestellt und Ihre IP-Adresse dorthin übermittelt.
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => setEinmaligGeladen(true)}
                        sx={{ color: 'black', background: '#8d3848' }}
                    >
                        Karte laden
                    </Button>
                    <Typography variant="caption">
                        Gilt nur für diesen Besuch.{' '}
                        <Link href={kartenUrl} target="_blank" rel="noopener noreferrer">
                            Direkt bei Google Maps öffnen
                        </Link>
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};
